module.exports = __webpack_public_path__ + "logo-mollie-new.0299d0373360d7e1c9691e38bf50ba12.svg";